import { CancelOutlined } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import "./FooterNavigation.scss";
import { devLog } from "utils/devLog";

/**
 *
 * @param {*} props
 * @returns
 */
export default function FooterNavigation(props) {
  const { t } = useTranslation();

  const onCancelClick = (e) => {
    devLog("UI Cancel pressed");
    if (typeof props.onCancelClick == "function") {
      props.onCancelClick();
    }
  };

  const onNextClick = (e) => {
    devLog("UI Next pressed");
    if (typeof props.onNextClick == "function") {
      props.onNextClick();
    }
  };

  return (
    <>
      <div className="footerContainer" style={{ display: "flex" }}>
        <div>
          <button
            id="cancelButton"
            type="button"
            className="footer"
            style={{ background: "#f4f4f4", color: "black", paddingLeft: 14 }}
            onClick={onCancelClick}
          >
            <CancelOutlined style={{ width: 20, color: "black", marginRight: 4 }} />
            <span style={{ marginLeft: "0px" }}>{t("description.CancelCallButton1")}</span>
          </button>
        </div>
        <div>
          <button type="submit" className="ui-btn" onClick={onNextClick}>
            {t("description.ConfirmCustomerSubmit")}
          </button>
        </div>
      </div>
    </>
  );
}
